import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Trazabilidad/comprobarStock`, method: 'POST', body: values, token: token})
}